import React from "react";

const Add = ({fill}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={fill ? fill : "#fff"} viewBox="0 0 24 24" strokeWidth="2" stroke={fill ? fill : "#fff"} className="size-5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>
  );
};

export default Add;
